import React, { Fragment, useEffect, useMemo, useState } from "react"
import DatePicker from "react-datepicker"
import Select from "react-select"
import AsyncSelect from "react-select/async"
import { Col, Row, Form } from "reactstrap"
import { customStylesSelect } from "common/data/settings"
import { getAuthorizationToken } from "helpers/storagehelper"

const Filter = props => {
  const {
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    handleSubmit,
    handleExport,
    companySetting,
    MainCategory,
    SubCategory,
    selectedClient,
    setSelectedClient,
    selectedProject,
    setSelectedProject,
    selectedEmployee,
    setSelectedEmployee,
  } = props

  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}")
  const [allUsers, setAllUsers] = useState([])

  // Sort helper for dropdowns
  const sortByName = (a, b) => (a?.name > b?.name ? 1 : a?.name < b?.name ? -1 : 0)

  const clientOptions = useMemo(
    () =>
      [{ label: "All", id: undefined }].concat(
        (MainCategory || [])
          .slice()
          .sort(sortByName)
          .map(el => ({ ...el, label: el.name, value: el.id }))
      ),
    [MainCategory]
  )

  const projectOptions = useMemo(() => {
    const filtered = selectedClient?.id
      ? (SubCategory || []).filter(el => el?.categoryId === selectedClient?.id)
      : SubCategory || []
    return [{ label: "All", id: undefined }].concat(
      filtered
        .slice()
        .sort(sortByName)
        .map(el => ({ ...el, label: el.name, value: el.id }))
    )
  }, [SubCategory, selectedClient])

  const getUserListData = async (searchValue, callback, searchKey = "useremail") => {
    try {
      const data = await fetch(
        `${process.env.REACT_APP_API_URL}/Users/GetUsers`,
        {
          method: "post",
          headers: {
            Authorization: `Bearer ${getAuthorizationToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            searchKey,
            searchValue,
            pageNumber: 0,
            pageSize: 20,
          }),
        }
      )
        .then(res => res.json())
        .then(res => {
          setAllUsers(res.data)
          return (res.data || []).map(el => ({
            ...el,
            label: el.username,
            value: el.id,
          }))
        })
      if (callback) callback(data)
      return data
    } catch (err) {
      console.log(err, "err")
      return []
    }
  }

  useEffect(() => {
    getUserListData(authUser.data?.firstname?.substr(0, 2) || "a", () => {}, undefined)
  }, [])

  const loadOptions = (inputValue, callback) => {
    getUserListData(inputValue, callback)
  }

  const clientFilter = value => {
    setSelectedClient(value?.id ? value : null)
    setSelectedProject(null)
  }

  const projectFilter = value => {
    setSelectedProject(value?.id ? value : null)
  }

  return (
    <Fragment>
      <Form onSubmit={handleSubmit}>
        <Row className="mb-2">
          <Col lg={2}>
            <label>From</label>
            <DatePicker
              dateFormat="yyyy-MM-dd"
              selected={startDate}
              onChange={date => setStartDate(date)}
              className="form-control mb-2 date-icon-back"
              placeholderText="Select date"
              maxDate={new Date()}
            />
          </Col>
          <Col lg={2}>
            <label>To</label>
            <DatePicker
              dateFormat="yyyy-MM-dd"
              selected={endDate}
              onChange={date => setEndDate(date)}
              className="form-control mb-2 date-icon-back"
              placeholderText="Select date"
              minDate={new Date(startDate)}
              maxDate={new Date()}
            />
          </Col>
          <Col lg={2}>
            <label>{companySetting?.MainCategory || "Client"}</label>
            <Select
              className="mb-2"
              value={selectedClient || { label: "All" }}
              onChange={value => clientFilter(value)}
              options={clientOptions}
              classNamePrefix="select2-selection"
              placeholder="All"
              styles={customStylesSelect}
            />
          </Col>
          <Col lg={2}>
            <label>{companySetting?.SubCategory || "Project"}</label>
            <Select
              className="mb-2"
              value={selectedProject || { label: "All" }}
              onChange={value => projectFilter(value)}
              options={projectOptions}
              classNamePrefix="select2-selection"
              placeholder="All"
              styles={customStylesSelect}
            />
          </Col>
          <Col lg={2}>
            <label>Employee</label>
            <AsyncSelect
              styles={customStylesSelect}
              value={selectedEmployee}
              isClearable
              onChange={value => setSelectedEmployee(value)}
              cacheOptions
              loadOptions={loadOptions}
              defaultOptions={[{ label: "All", value: undefined }].concat(
                (allUsers || []).map(el => ({
                  ...el,
                  label: el.username,
                  value: el.id,
                }))
              )}
              classNamePrefix="select2-selection"
              placeholder="All"
            />
          </Col>
          <Col lg={2} className="d-flex align-items-end">
            <div className="d-flex mb-2">
              <button
                className="btn btn-primary me-2"
                type="submit"
                onClick={handleSubmit}
              >
                <i className="bx bx-filter-alt align-middle"></i> Filter
              </button>
              <button
                className="btn btn-primary"
                type="button"
                onClick={handleExport}
              >
                <i className="bx bx-download align-middle"></i> Export
              </button>
            </div>
          </Col>
        </Row>
      </Form>
    </Fragment>
  )
}

export default Filter
